const REAL_ESTATE_REGISTER_KEY = 'st_real_estate_register';

export const getRealEstateList = (userKey) => {
    const listString = window.localStorage.getItem(`${REAL_ESTATE_REGISTER_KEY}_${userKey ?? 'default'}`);
    return listString ? JSON.parse(listString) : [];
};

export const saveRealEstateList = (realEstateList, userKey) => {
    const listString = JSON.stringify(realEstateList);
    window.localStorage.setItem(`${REAL_ESTATE_REGISTER_KEY}_${userKey ?? 'default'}`, listString);
};

export const clearRealEstateList = (userKey) => {
    window.localStorage.removeItem(`${REAL_ESTATE_REGISTER_KEY}_${userKey ?? 'default'}`);
};

export default { 
    getRealEstateList, 
    saveRealEstateList, 
    clearRealEstateList,
};